import { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import HeaderContainer from './components/HeaderContainer.jsx'
import Navbar from './components/Navbar.jsx'
import MainSection from './components/MainSection.jsx'
import Footer from './components/Footer.jsx'

function AppContent() {
	const [activeSection, setActiveSection] = useState('menu');
	const location = useLocation();

	useEffect(() => {
		// Route değişikliklerinde activeSection'ı güncelle
		const path = location.pathname;
		if (path === '/') {
			setActiveSection('menu');
		} else if (path === '/tostlar') {
			setActiveSection('tostlar');
		} else if (path === '/sicak-kahveler') {
			setActiveSection('sicak-kahveler');
		} else if (path === '/sicak-icecekler') {
			setActiveSection('sicak-icecekler');
		} else if (path === '/sicak-icecekler/buyuk-cay') {
			setActiveSection('buyuk-cay');
		} else if (path === '/sicak-icecekler/filtre-kahve') {
			setActiveSection('filtre-kahve');
		} else if (path === '/sicak-icecekler/sutlu-filtre-kahve') {
			setActiveSection('sutlu-filtre-kahve');
		} else if (path === '/sicak-icecekler/sicak-cikolata') {
			setActiveSection('sicak-cikolata');
		} else if (path === '/sicak-icecekler/kahveli-sicak-cikolata') {
			setActiveSection('kahveli-sicak-cikolata');
		} else if (path === '/sicak-icecekler/sicak-beyaz-cikolata') {
			setActiveSection('sicak-beyaz-cikolata');
		} else if (path === '/sicak-icecekler/salep') {
			setActiveSection('salep');
		} else if (path === '/sicak-icecekler/salepli-kahve') {
			setActiveSection('salepli-kahve');
		} else if (path === '/sicak-icecekler/chai-tea-latte') {
			setActiveSection('chai-tea-latte');
		} else if (path === '/sicak-icecekler/matcha-tea-latte') {
			setActiveSection('matcha-tea-latte');
		} else if (path === '/sicak-icecekler/detox') {
			setActiveSection('detox');
		} else if (path === '/sicak-icecekler/sicak-berry-hibiscus') {
			setActiveSection('sicak-berry-hibiscus');
		} else if (path === '/sicak-icecekler/theraphy') {
			setActiveSection('theraphy');
		} else if (path === '/sicak-icecekler/masala') {
			setActiveSection('masala');
		} else if (path === '/sicak-icecekler/form') {
			setActiveSection('form');
		} else if (path === '/sicak-icecekler/cool') {
			setActiveSection('cool');
		} else if (path === '/sicak-icecekler/rooibos-vanillia') {
			setActiveSection('rooibos-vanillia');
		} else if (path === '/sicak-icecekler/white-blue') {
			setActiveSection('white-blue');
		} else if (path === '/sicak-icecekler/papatya') {
			setActiveSection('papatya');
		} else if (path === '/sicak-icecekler/melisa') {
			setActiveSection('melisa');
		} else if (path === '/sicak-icecekler/ihlamur') {
			setActiveSection('ihlamur');
		} else if (path === '/sicak-icecekler/elma-tarcin-karisik') {
			setActiveSection('elma-tarcin-karisik');
		} else if (path === '/soguk-kahveler') {
			setActiveSection('soguk-kahveler');
		} else if (path === '/soguk-icecekler') {
			setActiveSection('soguk-icecekler');
		} else if (path === '/limonata') {
			setActiveSection('limonata');
		} else if (path === '/portakal-suyu') {
			setActiveSection('portakal-suyu');
		} else if (path === '/milkshake') {
			setActiveSection('milkshake');
		} else if (path === '/frozen') {
			setActiveSection('frozen');
		} else if (path === '/ayran') {
			setActiveSection('ayran');
		} else if (path === '/feslegenli-ayran') {
			setActiveSection('feslegenli-ayran');
		} else if (path === '/kokteyller') {
			setActiveSection('kokteyller');
		} else if (path === '/turk-kahveleri') {
			setActiveSection('turk-kahveleri');
		} else if (path === '/mesrubatlar') {
			setActiveSection('mesrubatlar');
		} else if (path === '/yemekler') {
			setActiveSection('yemekler');
		} else if (path === '/dostluk-pekistirenler') {
			setActiveSection('dostluk-pekistirenler');
		} else if (path === '/gozlemeler') {
			setActiveSection('gozlemeler');
		} else if (path === '/hamburgerler') {
			setActiveSection('hamburgerler');
		} else if (path === '/makarnalar') {
			setActiveSection('makarnalar');
		} else if (path === '/wraplar') {
			setActiveSection('wraplar');
		} else if (path === '/online-magaza') {
			setActiveSection('online-magaza');
		}
	}, [location]);

	const handleSectionChange = (section) => {
		setActiveSection(section);
	};

	return (
		<>
			<HeaderContainer onSectionChange={handleSectionChange} />
			<Navbar activeSection={activeSection} onSectionChange={handleSectionChange} />
			<Routes>
				<Route path="/" element={<MainSection activeSection={activeSection} />} />
				<Route path="/online-magaza" element={<MainSection activeSection="online-magaza" />} />
				<Route path="/sicak-kahveler" element={<MainSection activeSection="sicak-kahveler" />} />
				<Route path="/sicak-icecekler" element={<MainSection activeSection="sicak-icecekler" />} />
				<Route path="/sicak-icecekler/buyuk-cay" element={<MainSection activeSection="buyuk-cay" />} />
				<Route path="/sicak-icecekler/filtre-kahve" element={<MainSection activeSection="filtre-kahve" />} />
				<Route path="/sicak-icecekler/sutlu-filtre-kahve" element={<MainSection activeSection="sutlu-filtre-kahve" />} />
				<Route path="/sicak-icecekler/sicak-cikolata" element={<MainSection activeSection="sicak-cikolata" />} />
				<Route path="/sicak-icecekler/kahveli-sicak-cikolata" element={<MainSection activeSection="kahveli-sicak-cikolata" />} />
				<Route path="/sicak-icecekler/sicak-beyaz-cikolata" element={<MainSection activeSection="sicak-beyaz-cikolata" />} />
				<Route path="/sicak-icecekler/salep" element={<MainSection activeSection="salep" />} />
				<Route path="/sicak-icecekler/salepli-kahve" element={<MainSection activeSection="salepli-kahve" />} />
				<Route path="/sicak-icecekler/chai-tea-latte" element={<MainSection activeSection="chai-tea-latte" />} />
				<Route path="/sicak-icecekler/matcha-tea-latte" element={<MainSection activeSection="matcha-tea-latte" />} />
				<Route path="/sicak-icecekler/detox" element={<MainSection activeSection="detox" />} />
				<Route path="/sicak-icecekler/sicak-berry-hibiscus" element={<MainSection activeSection="sicak-berry-hibiscus" />} />
				<Route path="/sicak-icecekler/theraphy" element={<MainSection activeSection="theraphy" />} />
				<Route path="/sicak-icecekler/masala" element={<MainSection activeSection="masala" />} />
				<Route path="/sicak-icecekler/form" element={<MainSection activeSection="form" />} />
				<Route path="/sicak-icecekler/cool" element={<MainSection activeSection="cool" />} />
				<Route path="/sicak-icecekler/rooibos-vanillia" element={<MainSection activeSection="rooibos-vanillia" />} />
				<Route path="/sicak-icecekler/white-blue" element={<MainSection activeSection="white-blue" />} />
				<Route path="/sicak-icecekler/papatya" element={<MainSection activeSection="papatya" />} />
				<Route path="/sicak-icecekler/melisa" element={<MainSection activeSection="melisa" />} />
				<Route path="/sicak-icecekler/ihlamur" element={<MainSection activeSection="ihlamur" />} />
				<Route path="/sicak-icecekler/elma-tarcin-karisik" element={<MainSection activeSection="elma-tarcin-karisik" />} />
				<Route path="/sicak-kahveler/cafe-latte" element={<MainSection activeSection="cafe-latte" />} />
				<Route path="/sicak-kahveler/cappuccino" element={<MainSection activeSection="cappuccino" />} />
				<Route path="/sicak-kahveler/espresso" element={<MainSection activeSection="espresso" />} />
				<Route path="/sicak-kahveler/double-espresso" element={<MainSection activeSection="double-espresso" />} />
				<Route path="/sicak-kahveler/cortada" element={<MainSection activeSection="cortada" />} />
				<Route path="/sicak-kahveler/espresso-macchiato" element={<MainSection activeSection="espresso-macchiato" />} />
				<Route path="/sicak-kahveler/double-espresso-macchiato" element={<MainSection activeSection="double-espresso-macchiato" />} />
				<Route path="/sicak-kahveler/espresso-con-panna" element={<MainSection activeSection="espresso-con-panna" />} />
				<Route path="/sicak-kahveler/double-espresso-con-panna" element={<MainSection activeSection="double-espresso-con-panna" />} />
				<Route path="/sicak-kahveler/cafe-latte-macchiato" element={<MainSection activeSection="cafe-latte-macchiato" />} />
				<Route path="/sicak-kahveler/flat-white" element={<MainSection activeSection="flat-white" />} />
				<Route path="/sicak-kahveler/ristretto" element={<MainSection activeSection="ristretto" />} />
				<Route path="/sicak-kahveler/lungo-espresso" element={<MainSection activeSection="lungo-espresso" />} />
				<Route path="/sicak-kahveler/americano" element={<MainSection activeSection="americano" />} />
				<Route path="/sicak-kahveler/red-eye" element={<MainSection activeSection="red-eye" />} />
				<Route path="/sicak-kahveler/cikolatali-mocha" element={<MainSection activeSection="cikolatali-mocha" />} />
				<Route path="/sicak-kahveler/beyaz-cikolatali-mocha" element={<MainSection activeSection="beyaz-cikolatali-mocha" />} />
				<Route path="/sicak-kahveler/karamelli-mocha" element={<MainSection activeSection="karamelli-mocha" />} />
				<Route path="/sicak-kahveler/zebra" element={<MainSection activeSection="zebra" />} />
				<Route path="/sicak-kahveler/cikita-coffee" element={<MainSection activeSection="cikita-coffee" />} />
				<Route path="/sicak-kahveler/chery-chery-lady" element={<MainSection activeSection="chery-chery-lady" />} />
				<Route path="/sicak-kahveler/valentines-coffee" element={<MainSection activeSection="valentines-coffee" />} />
				<Route path="/sicak-kahveler/irish-cream-coffee" element={<MainSection activeSection="irish-cream-coffee" />} />
				<Route path="/sicak-kahveler/baileys-coffee-alkolsuz" element={<MainSection activeSection="baileys-coffee-alkolsuz" />} />
				<Route path="/soguk-kahveler" element={<MainSection activeSection="soguk-kahveler" />} />
				<Route path="/soguk-icecekler" element={<MainSection activeSection="soguk-icecekler" />} />
				<Route path="/soguk-icecekler/limonata" element={<MainSection activeSection="limonata" />} />
				<Route path="/soguk-icecekler/portakal-suyu" element={<MainSection activeSection="portakal-suyu" />} />
				<Route path="/soguk-icecekler/milkshake" element={<MainSection activeSection="milkshake" />} />
				<Route path="/soguk-icecekler/frozen" element={<MainSection activeSection="frozen" />} />
				<Route path="/soguk-icecekler/ayran" element={<MainSection activeSection="ayran" />} />
				<Route path="/soguk-icecekler/feslegenli-ayran" element={<MainSection activeSection="feslegenli-ayran" />} />
				<Route path="/soguk-kahveler/mavi-cilekli-ice-latte" element={<MainSection activeSection="mavi-cilekli-ice-latte" />} />
				<Route path="/soguk-kahveler/italyan-karamel-ice-latte" element={<MainSection activeSection="italyan-karamel-ice-latte" />} />
				<Route path="/soguk-kahveler/tuzlu-karamel-ice-latte" element={<MainSection activeSection="tuzlu-karamel-ice-latte" />} />
				<Route path="/soguk-kahveler/baileys-ice-latte" element={<MainSection activeSection="baileys-ice-latte" />} />
				<Route path="/soguk-kahveler/virginia-coffee" element={<MainSection activeSection="virginia-coffee" />} />
				<Route path="/soguk-kahveler/waka-waka" element={<MainSection activeSection="waka-waka" />} />
				<Route path="/soguk-kahveler/cool-nut" element={<MainSection activeSection="cool-nut" />} />
				<Route path="/soguk-kahveler/oreo-coffee" element={<MainSection activeSection="oreo-coffee" />} />
				<Route path="/soguk-kahveler/kitirli" element={<MainSection activeSection="kitirli" />} />
				<Route path="/soguk-kahveler/sipsevdi" element={<MainSection activeSection="sipsevdi" />} />
				<Route path="/soguk-kahveler/sweet-baby" element={<MainSection activeSection="sweet-baby" />} />
				<Route path="/soguk-kahveler/melon-sapka" element={<MainSection activeSection="melon-sapka" />} />
				<Route path="/soguk-kahveler/cheese-cake" element={<MainSection activeSection="cheese-cake" />} />
				<Route path="/soguk-kahveler/java-chip" element={<MainSection activeSection="java-chip" />} />
				<Route path="/soguk-kahveler/ice-americano" element={<MainSection activeSection="ice-americano" />} />
				<Route path="/soguk-kahveler/ice-latte" element={<MainSection activeSection="ice-latte" />} />
				<Route path="/soguk-kahveler/ice-cappuccino" element={<MainSection activeSection="ice-cappuccino" />} />
				<Route path="/soguk-kahveler/frappe" element={<MainSection activeSection="frappe" />} />
				<Route path="/soguk-kahveler/cold-brew" element={<MainSection activeSection="cold-brew" />} />
				<Route path="/soguk-kahveler/affogato" element={<MainSection activeSection="affogato" />} />
				<Route path="/soguk-kahveler/ice-cikolatali-mocha" element={<MainSection activeSection="ice-cikolatali-mocha" />} />
				<Route path="/soguk-kahveler/ice-beyaz-cikolatali-mocha" element={<MainSection activeSection="ice-beyaz-cikolatali-mocha" />} />
				<Route path="/soguk-kahveler/ice-karamelli-mocha" element={<MainSection activeSection="ice-karamelli-mocha" />} />
				<Route path="/kokteyller" element={<MainSection activeSection="kokteyller" />} />
				<Route path="/kokteyller/lalika" element={<MainSection activeSection="lalika" />} />
				<Route path="/kokteyller/cool-lime-cilekli" element={<MainSection activeSection="cool-lime-cilekli" />} />
				<Route path="/kokteyller/cool-lime-mentollu" element={<MainSection activeSection="cool-lime-mentollu" />} />
				<Route path="/kokteyller/sangria" element={<MainSection activeSection="sangria" />} />
				<Route path="/kokteyller/blue-lagoon" element={<MainSection activeSection="blue-lagoon" />} />
				<Route path="/kokteyller/blue-hawai" element={<MainSection activeSection="blue-hawai" />} />
				<Route path="/kokteyller/berry-hibiscus" element={<MainSection activeSection="berry-hibiscus" />} />
				<Route path="/turk-kahveleri" element={<MainSection activeSection="turk-kahveleri" />} />
				<Route path="/mesrubatlar" element={<MainSection activeSection="mesrubatlar" />} />
				<Route path="/yemekler" element={<MainSection activeSection="yemekler" />} />
				<Route path="/dostluk-pekistirenler" element={<MainSection activeSection="dostluk-pekistirenler" />} />
				<Route path="/dostluk-pekistirenler/combo-sicak-tabagi" element={<MainSection activeSection="combo-sicak-tabagi" />} />
				<Route path="/dostluk-pekistirenler/combo-burger" element={<MainSection activeSection="combo-burger" />} />
				<Route path="/dostluk-pekistirenler/cajun-basket" element={<MainSection activeSection="cajun-basket" />} />
				<Route path="/dostluk-pekistirenler/borek-basket" element={<MainSection activeSection="borek-basket" />} />
				<Route path="/dostluk-pekistirenler/patates-tabagi" element={<MainSection activeSection="patates-tabagi" />} />
				<Route path="/dostluk-pekistirenler/patso" element={<MainSection activeSection="patso" />} />
				<Route path="/dostluk-pekistirenler/sosis-basket" element={<MainSection activeSection="sosis-basket" />} />
				<Route path="/gozlemeler" element={<MainSection activeSection="gozlemeler" />} />
				<Route path="/hamburgerler" element={<MainSection activeSection="hamburgerler" />} />
				<Route path="/hamburgerler/hamburger" element={<MainSection activeSection="hamburger" />} />
				<Route path="/hamburgerler/hamburg-er" element={<MainSection activeSection="hamburger" />} />
				<Route path="/hamburgerler/cift-kofte-tek-lezzet" element={<MainSection activeSection="cift-kofte-tek-lezzet" />} />
				<Route path="/makarnalar" element={<MainSection activeSection="makarnalar" />} />
				<Route path="/makarnalar/alfredo" element={<MainSection activeSection="alfredo" />} />
				<Route path="/makarnalar/pasta-italiano" element={<MainSection activeSection="pasta-italiano" />} />
				<Route path="/makarnalar/pesto" element={<MainSection activeSection="pesto" />} />
				<Route path="/makarnalar/chicken-mushroom" element={<MainSection activeSection="chicken-mushroom" />} />
				<Route path="/makarnalar/arabiatta" element={<MainSection activeSection="arabiatta" />} />
				<Route path="/tostlar" element={<MainSection activeSection="tostlar" />} />
				<Route path="/tostlar/kasarli-tost" element={<MainSection activeSection="kasarli-tost" />} />
				<Route path="/tostlar/kasarli-sucuklu-tost" element={<MainSection activeSection="kasarli-sucuklu-tost" />} />
				<Route path="/wraplar" element={<MainSection activeSection="wraplar" />} />
				<Route path="/wraplar/kofte-wrap" element={<MainSection activeSection="kofte-wrap" />} />
				<Route path="/wraplar/tavuklu-wrap" element={<MainSection activeSection="tavuklu-wrap" />} />
				<Route path="/turk-kahveleri" element={<MainSection activeSection="turk-kahveleri" />} />
				<Route path="/turk-kahveleri/turk-kahvesi" element={<MainSection activeSection="turk-kahvesi" />} />
				<Route path="/turk-kahveleri/double-turk-kahvesi" element={<MainSection activeSection="double-turk-kahvesi" />} />
				<Route path="/turk-kahveleri/dibek-turk-kahvesi" element={<MainSection activeSection="dibek-turk-kahvesi" />} />
				<Route path="/turk-kahveleri/double-dibek-turk-kahvesi" element={<MainSection activeSection="double-dibek-turk-kahvesi" />} />
				<Route path="/turk-kahveleri/cilekli-turk-kahvesi" element={<MainSection activeSection="cilekli-turk-kahvesi" />} />
				<Route path="/turk-kahveleri/double-cilekli-turk-kahvesi" element={<MainSection activeSection="double-cilekli-turk-kahvesi" />} />
				<Route path="/turk-kahveleri/damla-sakizli-turk-kahvesi" element={<MainSection activeSection="damla-sakizli-turk-kahvesi" />} />
				<Route path="/turk-kahveleri/double-damla-sakizli-turk-kahvesi" element={<MainSection activeSection="double-damla-sakizli-turk-kahvesi" />} />
				<Route path="/turk-kahveleri/kumda-turk-kahvesi" element={<MainSection activeSection="kumda-turk-kahvesi" />} />
			</Routes>
			<Footer />
		</>
	)
}

function App() {
	return (
		<Router>
			<AppContent />
		</Router>
	)
}

export default App
